import { Box } from 'braid-design-system';
import React, { type ReactNode } from 'react';

import * as styles from './style.css';

interface Props {
  children: ReactNode;
  visible: boolean;
}

const ElementOverlay = ({ children, visible }: Props) => (
  <Box position="relative">
    <Box
      position="absolute"
      height="full"
      width="full"
      zIndex="dropdownBackdrop"
      transition="fast"
      display={['block', 'none']}
      pointerEvents={visible ? undefined : 'none'}
      opacity={!visible ? 0 : undefined}
      className={[styles.overlay, visible ? styles.overlayVisible : undefined]}
    />
    {children}
  </Box>
);

export default ElementOverlay;
